import { createSlice } from "@reduxjs/toolkit";

// Define the initial state of the modal
const initialState = {
  isOpen: false,
  title: "",
  subtitle: "",
  onCancel: () => {},
  onConfirm: () => {},
};

const deleteDialogSlice = createSlice({
  name: "deleteDialog",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.title = action.payload.title;
      state.subtitle = action.payload.subtitle;
      state.onCancel = action.payload.onCancel;
      state.onConfirm = action.payload.onConfirm;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.onCancel = () => {};
      state.onConfirm = () => {};
    },
  },
});

export const { openModal, closeModal } = deleteDialogSlice.actions;

export default deleteDialogSlice.reducer;
